import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {jsUcfirst} from '../util/utils';
import '../styles/css/dropdown.css';
import Spinner from './Spinner';


function renderListItems( onClick, quizResult) {
  let items = [];
  let types = ['dialog', 'pattern', 'voca', 'quiz'];

  types.map((type, i)=>(
    items.push(
      <div key={'quiz_'+i} onClick={(e)=>onClick(type, e)}>
        <span>{jsUcfirst(type)}</span>
      </div>
    )
  ))
  return items;
}

const WeekTable = (props) =>{
  const {weeks, state, show, onClick} = props;
  const {quizResult, status} = state;

  return (
    <Row className="week_table">
      <Col sm={6} smOffset={3} lg={4} lgOffset={4}>
        <div className="table_overflow note-table">
          {
            weeks.map((week, i)=>(
              !week.is_locked &&
              <div key={'week_'+(week.order)}
                className={"dropdown-container" + (status[i] ? " show" : "")}>
                <div className={"dropdown-display" + (status[i] ? " clicked": "")}
                  onClick={(e)=>show(i,e)} >
                  <span>Week {week.week_num}. {week.name}</span>
                  {status[i]?
                    <i className="glyphicon glyphicon-menu-up" />:
                    <i className="glyphicon glyphicon-menu-down" />
                  }
                </div>
                <div className="dropdown-list">
                  {/* <div className="note-week-spinner">
                    <Spinner />
                  </div> */}
                  {quizResult?
                    <div>
                      {renderListItems(onClick, quizResult)}
                    </div>:
                    <div className="note-week-spinner">
                      <Spinner />
                    </div>
                  }
                </div>
              </div>
            ))
          }
        </div>
      </Col>
    </Row>
  );
};



export default WeekTable;



// WEBPACK FOOTER //
// ./src/components/Note.WeekTable.js